import { render, staticRenderFns } from "./sysDict.vue?vue&type=template&id=0fdb21a7&scoped=true&"
import script from "./sysDict.vue?vue&type=script&lang=js&"
export * from "./sysDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb21a7",
  null
  
)

export default component.exports